import { apiV2, errorHandler } from "./index";
import { API_ERROR, FETCH_USER_STREAK, RESTORE_USER_STREAK, FETCH_USER_STREAK_ERROR } from "../constants/ActionTypes";

export function fetchUserStreak(options) {
  return function (dispatch) {
    apiV2.get(`/users/streak`, {
      params: {
        email: options.user_email,
        days: options.days,
      }
    })
      .then((response) => {
        dispatch({
          type: FETCH_USER_STREAK,
          payload: { data: response.data, days: options.days }
        });
      })
      .catch((error) => {
        dispatch({
          type: FETCH_USER_STREAK_ERROR,
          payload: []
        });
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}

export function restoreUserStreak(options) {
  return function (dispatch) {
    apiV2.post(`/users/streak/restore`, {
      email: options.user_email,
      days: options.days,
    })
      .then((response) => {
        dispatch({
          type: RESTORE_USER_STREAK,
          payload: response.data
        });
      })
      .catch((error) => {
        errorHandler(dispatch, error.response, API_ERROR);
      });
  };
}
